import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe, formatCurrency, getCurrencySymbol } from '@angular/common';
import { OrderPaymentStatusLabel, OrderPaymentTypeStatusLabel } from '../base/AppInterfaceAndBaseClasses';
import { SmartSTLRequestStatuses, SmartSTLTreatmentContext } from 'src/app/_appCommon/base/AppInterfaceAndBaseClasses';

@Pipe({ name: 'dynamic' })
export class DynamicPipe implements PipeTransform
{
  public transform(value: string, modifier: string)
  {
    if (!modifier) return value;
    if (value == undefined || value == null) return "";
    return eval('this.' + modifier + '(\'' + value + '\')');
  }

  //To get currency symbol
  currency(value: number): string | null
  {
    return formatCurrency(+value, 'es-MX', getCurrencySymbol('MXN', 'wide'), 'MXN', '1.2-2');
  }

  // To get date and hour
  dateTime(value: any): string
  {
    var date = new Date(this.ensureTimezoneDate(value));
    return new DatePipe('es-MX').transform(date, "dd/MM/yyyy hh:mm a");
  }

  // To get just date
  date(value: any): string
  {
    var date = new Date(this.ensureTimezoneDate(value));
    return new DatePipe('es-MX').transform(date, "dd/MM/yyyy");
  }

  public longDateTime(value: any): string
  {
    var date = new Date(this.ensureTimezoneDate(value));
    return new DatePipe("es-MX").transform(date, "dd MMMM hh:mm:ss");
  }

  age(value: any): string
  {
    let years = '0 años';
    let months = '0 meses';

    let today = new Date();
    let birthDate = new Date(value);

    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    let monthsNumber = today.getMonth() - birthDate.getMonth();
    let daysNumber = today.getDate() - birthDate.getDate();

    if (daysNumber < 0)
    {
      monthsNumber--;
    }

    if (monthsNumber < 0)
    {
      monthsNumber = 12 + monthsNumber;
    }

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate()))
    {
      age--;
    }

    if (monthsNumber > 0 && m != 0)
    {
      months = `${monthsNumber} ${monthsNumber > 1 ? 'meses' : 'mes'}`;
    }

    if (age > 0)
    {
      years = `${age} ${age > 1 ? 'años' : 'año'}`;
    }

    return `${years} ${months}`;
  }

  // To get date and hour
  UTCDateTime(value: any): string
  {
    return new DatePipe('es-MX').transform(value, "dd/MM/yyyy hh:mm a");
  }

  // To show uppercase text
  toUpper(value: string): string
  {
    return value.toUpperCase();
  }

  paymentStatus(value: number): string
  {
    return OrderPaymentStatusLabel.get(+value);
  }

  paymentType(value: number): string
  {
    return OrderPaymentTypeStatusLabel.get(+value);
  }

  private ensureTimezoneDate(value: string): string
  {
    if (value[value.length - 1].toLowerCase() != 'z')
    {
      value = value + 'Z';
    }
    return value;
  }

  private smartSTLRequestStatuses(value: string): string | undefined {
    for (let [key, val] of SmartSTLRequestStatuses) {
      if (val === value) {
        return key;
      }
    }
    return undefined; // Si no se encuentra el valor
  }

  private smartSTLTreatmentContext(value: string): string | undefined {
    for (let [key, val] of SmartSTLTreatmentContext) {
      if (val === value) {
        return key;
      }
    }
    return undefined; // Si no se encuentra el valor
  }
}
